/**
 * Based on https://github.com/jsonmaur/phoenix-turnstile/blob/master/priv/static/phoenix_turnstile.js
 */

const intervalTime = 250
const resetDelayTime = 250
const maxErrorResets = 3

function getTurnstile() {
  return (window as any).turnstile
}

function pushCallbackEvent(self: any, name: string, eventName?: string) {
  return (payload: any) => {
    const events = self.el.dataset.events || ''

    if (events.split(',').indexOf(name) > -1) {
      self.pushEventTo(self.el, `cf_turnstile:${eventName || name}`, payload)
    }
  }
}

function handleSuccess(self: any) {
  const pushSuccess = pushCallbackEvent(self, 'success')

  return (payload: any) => {
    self.errorResets = 0
    pushSuccess(payload)
  }
}

function handleError(self: any) {
  const pushError = pushCallbackEvent(self, 'error')

  return (payload: any) => {
    pushError(payload)

    // Cloudflare emits transient errors (e.g. 300030) that leave the widget
    // dead. Reset a bounded number of times to obtain a fresh challenge instead
    // of forcing the user to reload the page.
    if (self.errorResets >= maxErrorResets) {
      // Give up self-healing and let Cloudflare show its default error UI.
      return false
    }

    self.errorResets += 1
    self.resetTimeoutId = setTimeout(() => {
      getTurnstile().reset(self.widgetId)
    }, resetDelayTime)

    // Returning true suppresses Cloudflare's default error UI while we retry.
    return true
  }
}

function setupTurnstile(self: any) {
  // Guard against a second render on the same element (leaked poll, re-mount).
  if (self.widgetId != null) {
    return
  }

  const turnstile = getTurnstile()

  self.widgetId = turnstile.render(self.el, {
    callback: handleSuccess(self),
    'error-callback': handleError(self),
  })

  self.handleEvent('turnstile:refresh', (event: any) => {
    if (!event.id || event.id === self.el.id) {
      self.errorResets = 0

      if (self.widgetId != null) {
        turnstile.reset(self.widgetId)
      }
    }
  })
}

export const CloudflareTurnstileHook = {
  mounted() {
    const self = this as any
    self.widgetId = null
    self.errorResets = 0
    self.intervalId = null
    self.resetTimeoutId = null

    if (typeof getTurnstile() !== 'undefined') {
      setupTurnstile(self)
      return
    }

    self.intervalId = setInterval(() => {
      if (typeof getTurnstile() !== 'undefined') {
        clearInterval(self.intervalId)
        self.intervalId = null
        setupTurnstile(self)
      }
    }, intervalTime)
  },

  destroyed() {
    const self = this as any

    if (self.intervalId != null) {
      clearInterval(self.intervalId)
    }

    if (self.resetTimeoutId != null) {
      clearTimeout(self.resetTimeoutId)
    }

    if (self.widgetId != null) {
      getTurnstile()?.remove(self.widgetId)
    }
  },
}
